import loadable from "@loadable/component";
import { useParams } from "react-router";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { usePDFPrintHook } from "@careinfo/layout";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import { queryClient } from "../../router/ReceiverManifestRouter";

const EditReceiveManifestComponent = loadable(
  () => import("../../components/ReceiveManifest/EditReceiveManifest")
);

const EditReceiveManifest = () => {
  const { id } = useParams();
  const [openalertPopup, setOpenAlertPopup] = useState(false);
  const [defaultValue, setDefaultValue] = useState(null);
  const { data, refetch, isLoading } = useGetHook({
    queryKey: [`mainfest-${id}`, "manifest"],
    url: `${APIS.MANIFEST}${id}/`,
    params: {},
  });
  const { data: gridData, isLoading: isgridDataLoading } = useGetHook({
    queryKey: [`manifest-status`],
    url: `${APIS.MANIFEST_STATUS}`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`manifest-${id}`, "manifest"],
    navigateURL: "",
  });
  const handleStatusChange = (data: any) => {
    setDefaultValue(data);
  };

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.MANIFEST}${id}/`;
    let formData = {
      ...values,
    };

    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  const { mutateAsync: checkConsignmentsMutateAsync } = usePostHook({
    queryKey: ["received-manifest-items"],
  });

  const handlecheckConsignments = async (
    consignmentId: string,
    setError: any
  ) => {
    const url = `${APIS.MANIFEST}receive-order/`;
    let formData = {
      tracking_number: consignmentId,
      manifest: id,
    };
    try {
      const res = await checkConsignmentsMutateAsync({
        url,
        formData,
        setError,
      });
      if (res?.status === 200) {
        queryClient.refetchQueries();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const { downloadPrint, isPrintLoading } = usePDFPrintHook();

  const handlePrint = async () => {
    const url = `${APIS.MANIFEST}${id}/print-pdf-manifest/`;
    let formData = {};
    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Manifest
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditReceiveManifestComponent
          isLoading={isPatchLoading}
          data={data}
          handleEdit={handleEdit}
          gridData={gridData}
          handlePrint={handlePrint}
          openalertPopup={openalertPopup}
          setOpenAlertPopup={setOpenAlertPopup}
          isPrintLoading={isPrintLoading}
          id={id}
          handlecheckConsignments={handlecheckConsignments}
          handleStatusChange={handleStatusChange}
          defaultValue={defaultValue}
        />
      )}
    </>
  );
};
export default EditReceiveManifest;
